<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
import Jt from '@/utils/jt';
import {isMQB, isIos, isAdr} from '@/constants';
export default {
    created() {
        const Jt_D = Jt.dom;
        const body = document.body;
        if(isMQB) {
            Jt_D.addClass(body, 'is-mqb');
        }
        if(isIos) {
            Jt_D.addClass(body, 'is-ios');
        } else if(isAdr) {
            Jt_D.addClass(body, 'is-adr');
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue